import * as v from 'valibot';

export const setupValibotI18n = (): void => {
  v.setGlobalMessage('Invalid value.');
  v.setSchemaMessage('This field is required.');

  v.setSpecificMessage(v.string, 'This field is required.');
  v.setSpecificMessage(v.number, 'Expected a number.');
  v.setSpecificMessage(v.boolean, 'Expected a boolean.');
  v.setSpecificMessage(v.bigint, 'Expected a bigint.');
  v.setSpecificMessage(v.date, 'Expected a date.');
  v.setSpecificMessage(v.array, 'Expected an array.');
  v.setSpecificMessage(v.object, 'Expected an object.');
  v.setSpecificMessage(v.literal, 'Invalid value.');
  v.setSpecificMessage(v.picklist, 'Select a value from the list.');
  v.setSpecificMessage(v.enum, 'Invalid value.');
  v.setSpecificMessage(v.union, 'Invalid value.');

  v.setSpecificMessage(v.nonEmpty, 'This field is required.');
  v.setSpecificMessage(v.email, 'Invalid email address.');
  v.setSpecificMessage(v.url, 'Invalid URL.');
  v.setSpecificMessage(v.uuid, 'Invalid UUID.');
  v.setSpecificMessage(v.integer, 'Expected an integer.');
  v.setSpecificMessage(v.regex, 'Value does not match the expected pattern.');
  v.setSpecificMessage(v.isoDate, 'Invalid date.');
  v.setSpecificMessage(v.isoDateTime, 'Invalid date and time.');
  v.setSpecificMessage(v.isoTime, 'Invalid time.');

  v.setSpecificMessage(
    v.minLength,
    (issue) => `Must be at least ${issue.requirement} characters.`,
  );
  v.setSpecificMessage(
    v.maxLength,
    (issue) => `Must be at most ${issue.requirement} characters.`,
  );
  v.setSpecificMessage(
    v.length,
    (issue) => `Must be exactly ${issue.requirement} characters.`,
  );
  v.setSpecificMessage(
    v.minValue,
    (issue) => `Minimum value is ${issue.requirement}.`,
  );
  v.setSpecificMessage(
    v.maxValue,
    (issue) => `Maximum value is ${issue.requirement}.`,
  );
  v.setSpecificMessage(
    v.minSize,
    (issue) => `At least ${issue.requirement} items required.`,
  );
  v.setSpecificMessage(
    v.maxSize,
    (issue) => `At most ${issue.requirement} items allowed.`,
  );
};
